// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2qi6G","row":"Node_row__GKspT","label":"Node_label__1XjpK","footer":"Node_footer__3Vi8-"};